import { render, staticRenderFns } from "./groupedCard.vue?vue&type=template&id=71220b5f&scoped=true&"
import script from "./groupedCard.vue?vue&type=script&lang=js&"
export * from "./groupedCard.vue?vue&type=script&lang=js&"
import style0 from "./groupedCard.vue?vue&type=style&index=0&id=71220b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71220b5f",
  null
  
)

export default component.exports